/** Curated IANA zones for store settings; server validates any value via pg_timezone_names. */
export const COMMON_STORE_TIMEZONES = [
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'UTC',
] as const;

export function browserTimezone(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz && tz.length > 0 ? tz : 'America/Los_Angeles';
  } catch {
    return 'America/Los_Angeles';
  }
}

/** Options for a <select>, always including the store's current value. */
export function storeTimezoneOptions(current?: string | null): string[] {
  const base = [...COMMON_STORE_TIMEZONES];
  const cur = current?.trim();
  if (cur && !base.includes(cur as (typeof COMMON_STORE_TIMEZONES)[number])) {
    return [cur, ...base];
  }
  return base;
}
